import React, {Component} from "react";
import {connect} from "react-redux";
import {logoutUser} from "../../actions";
import {saveParentData} from "../../actions";
import parentData from "../Data/ParentData.json";
import DaySelction from "./DaySelection.js";
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import ShowGeneralInfo from "./GeneralInfo.js";
import {myFirebase} from "../../firebase/firebase";
import Container from "@material-ui/core/Container";
import {Button} from '@material-ui/core';
import {ChildDisabilities, ExtraChildDisabilities} from "./ChildDisabilities";
import SetHeadline from "./SetHeadline.js"
import useStyles from "./FormStyle"
import {withStyles} from '@material-ui/core/styles';
import Female from "./Female";
import Male from "./Male";
import ActivityStatus from "./ActivityStatus.js"
import "./gender.css"
import ExtraChild from "./ExtraChild";
import Toolbar from "../Menu/Toolbar";
import SideDrawer from "../Menu/SideDrawer";
import BackDrop from "../Menu/BackDrop";
import ShowDaySelction from "./ShowDaySelection.js"
import Autocomplete from '@material-ui/lab/Autocomplete';
import cities from './CitiesNames.js';
import {green_style} from "../styles"

const checkInput = require("./CheckInput");


class ParentSignup extends Component {
    constructor() {
        super();
        this.showGeneralInfo = React.createRef();
        this.state = {
            isLoading: true,
            allData: {},
            menuOpen: false,
            city: "",
            email: "",
            activity_status: '',
            first_signup_headline: " מוזמנים למלא את כל הפרטים הבאים על ילדיכם ולאחר ההרשמה נציג את הבייביסיטרים המיוחדים הרלוונטים עבורכם.",
            child_gender: "",
            extra_child_gender: "",
            userData: parentData,
            child_age: '',
            show_day_selection: false,
            extra_child: false,
            registration_date: new Date().toLocaleString(),
            errors: {
                child_age: '',
                city: ''
            }
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleChangeCombo = this.handleChangeCombo.bind(this);

    }

    menuClickHandler = () => {
        this.setState((prevState) => {
            return {menuOpen: !prevState.menuOpen};
        });
    };

    backDropClickHandler = () => {
        this.setState({menuOpen: false});
    };

    handleInputChange = evt => {
        var value = evt.target.value;
        var type = evt.target.name;
        let errors = this.state.errors;
        switch (type) {
            case "child_age":
                errors.child_age =
                    !checkInput.numbersCheck(value, 0, 120)
                        ? 'גיל הילד אינו תקין'
                        : '';
                break;
        }
        this.setState({errors, [type]: value}, () => {
            console.log(errors)
        })
    };

    handleLogout = () => {
        const {dispatch} = this.props;
        dispatch(logoutUser());
    };

    handleChange(event) {
        const {name, value, type, checked} = event.target;
        type === "checkbox" ? this.setState({[name]: checked}) : this.setState({[name]: value});
    }

    handleSaveData = () => {
        const {dispatch} = this.props;
        if (!this.checkAllData()) {
            window.alert("ישנם שדות שאינם תקינים");
        } else {
            var parent_data;
            if(this.state.activity_status === '') {
                parent_data = loadParentData(true, this.state.city, this.state.show_day_selection);
            } else {
                parent_data = loadParentData(false, this.state.city, this.state.show_day_selection);
            }
            dispatch(saveParentData(parent_data));
            if (this.props.currUser !== undefined) {
                this.props.history.push('/');
            } else {
                this.props.history.push('/confirm');
            }
        }
    };

    checkAllData = () => {
        var genValid = this.showGeneralInfo.current.checkAllIputValidation();
        let errors = this.state.errors;
        console.log(this.state.city)
        errors.child_age =
            !checkInput.numbersCheck(this.state.child_age,0,120)
            ? 'גיל הילד אינו תקין'
            : '';
        errors.city = 
            this.state.city == "" || this.state.city == null 
            ? 'שם עיר אינו תקין'
            : '';
        this.setState({errors}, ()=> {
            console.log(errors)
        });
        return !!(checkInput.validateForm(this.state.errors) && genValid);
    };

    async componentWillMount() {
        if (this.props.currUser !== null) {
            //let user_data = this.props.location.state.user;
            if (this.props.currUser.extra_child.child_age !== "") {
                this.setState({extra_child: true})
            }
            this.setState({city :this.props.currUser.city})
            this.setState({userData :this.props.currUser})
            this.setState({first_signup_headline :""});
            this.setState({child_age : this.props.currUser.child_age});
            this.setState({activity_status : <ActivityStatus userStatus={this.props.currUser.activity_status}/>})
        } 
    };

    handleChangeCombo = (fieldName, value) => {
        this.setState({[fieldName]: value});
        let errors = this.state.errors;
        this.setState({type: value});
        errors.city = 
            value == ""
            ? 'שם עיר אינו תקין'
            : '';
        this.setState({errors, "city": value}, ()=> {
            console.log(errors)
        })
    }

    setRegisterButtonLable = () => {
        let lable;
        if (this.props.currUser !== null) {
            lable = "עדכון פרסום"
        } else {
            lable = "הרשמה"
        }
        return (
            <Button variant="contained" style={green_style} size="large" disableElevation onClick={this.handleSaveData}>
                {lable}
            </Button>
        );
    };
    extraChildStatus = () => {
        this.setState(prevStatus => {
            return {extra_child: !prevStatus.extra_child}
        })
    };
    handleShowJobDetails = () => {
        this.setState(prevStatus => {
            return {show_day_selection: !prevStatus.show_day_selection}
        })
    };

    render() {
        let headline;
        var sideDrawer;
        var backDrop;
        // for an existing user display "my account" toolbar with menu button.
        if (this.props.currUser != undefined) {
            headline = <Toolbar drawerClickHandler={this.menuClickHandler} textPage="החשבון שלי"/>
            if (this.state.menuOpen) {
                sideDrawer = <SideDrawer closeMenu={this.backDropClickHandler}/>;
                backDrop = <BackDrop click={this.backDropClickHandler}/>;
            }
            // for new user display "signup" toolbar with no menu button.
        } else {
            headline = <SetHeadline type="כהורה"/>
            sideDrawer = <div></div>
            backDrop = <div></div>
        }
        const errStyle = {
            color: 'red',
            fontSize: '12px',
            textAlign: 'right',
            fontWeight: 'bold',
        };
        const {errors} = this.state;
        const {isLoggingOut, logoutError} = this.props;
        const {classes} = this.props;
        const child_info = <React.Fragment>
            <div className={classes.child_info_text} style={{fontFamily: "Open Sans Hebrew"}}>
                פרטי הילד/ה
            </div>
            <br/>

            <div className={classes.input_text} style={{fontFamily: "Open Sans Hebrew"}}>
                * מגדר הילד/ה
            </div>
            <label>
                <input type="radio"
                       name="child_gender"
                       value="female"
                       defaultChecked={this.state.userData.child_gender === "female"}
                       onChange={this.handleChange}
                />
                <Female/>
            </label>
            <label>
                <input type="radio"
                       name="child_gender"
                       value="male"
                       defaultChecked={this.state.userData.child_gender === "male"}
                       onChange={this.handleChange}
                />
                <Male/>
            </label>

            <br/>
            <br/>
            <FormControl variant="outlined" fullWidth>
                <div className={classes.input_text} style={{fontFamily: "Open Sans Hebrew"}}>
                    * גיל הילד/ה
                </div>
                <TextField name="child_age"
                           onChange={this.handleInputChange}
                           defaultValue={this.state.userData.child_age}
                           type="text"
                           fullWidth
                />
                <p>{errors.child_age.length > 0 &&
                <span style={errStyle} className='error'>{errors.child_age}</span>}</p>
            </FormControl>

            <p className={classes.input_text}>אבחון מוגבלות הילד : </p>
            <ChildDisabilities user={this.state.userData} type="parent"/>
            <FormControl variant="outlined" fullWidth>
                <div className={classes.input_text} style={{fontFamily: "Open Sans Hebrew"}}>
                    רמת תפקוד של הילד/ה
                </div>
                <Select className={classes.input_text} name="child_functional_level"
                        defaultValue={this.state.userData.child_functional_level}
                        native labelWidth="100">
                    <option value="high">רמת תפקוד גבוהה</option>
                    <option value="medium">רמת תפקוד בינונית</option>
                    <option value="low">רמת תפקוד נמוכה</option>
                </Select>
            </FormControl>
        </React.Fragment>;

        const extra_child_info = <React.Fragment>
            <div className={classes.child_info_text} style={{fontFamily: "Open Sans Hebrew"}}>
                פרטי הילד/ה
            </div>
            <br/>

            <div className={classes.input_text} style={{fontFamily: "Open Sans Hebrew"}}>
                * מגדר הילד/ה
            </div>
            <label>
                <input type="radio"
                       name="extra_child_gender"
                       value="female"
                       defaultChecked={this.state.userData.extra_child.child_gender === "female"}
                       onChange={this.handleChange}
                />
                <Female/>
            </label>
            <label>
                <input type="radio"
                       name="extra_child_gender"
                       value="male"
                       defaultChecked={this.state.userData.extra_child.child_gender === "male"}
                       onChange={this.handleChange}
                />
                <Male/>
            </label>

            <br/>
            <br/>
            <FormControl variant="outlined" fullWidth>
                <div className={classes.input_text} style={{fontFamily: "Open Sans Hebrew"}}>
                    * גיל הילד/ה
                </div>
                <TextField name="child_age"
                           onChange={this.handleInputChange}
                           defaultValue={this.state.userData.extra_child.child_age}
                           type="text"
                           fullWidth
                />
                <p>{errors.child_age.length > 0 &&
                <span style={errStyle} className='error'>{errors.child_age}</span>}</p>
            </FormControl>


            <p className={classes.input_text}>אבחון מוגבלות הילד : </p>
            <ExtraChildDisabilities user={this.state.userData}/>
            <FormControl variant="outlined" fullWidth>
                <div className={classes.input_text} style={{fontFamily: "Open Sans Hebrew"}}>
                    רמת תפקוד של הילד/ה
                </div>
                <Select className={classes.input_text} name="child_functional_level"
                        defaultValue={this.state.userData.extra_child.child_functional_level}
                        native labelWidth="100">
                    <option value="high">רמת תפקוד גבוהה</option>
                    <option value="medium">רמת תפקוד בינונית</option>
                    <option value="low">רמת תפקוד נמוכה</option>
                </Select>
            </FormControl>
        </React.Fragment>;
        const day_selecetions = <React.Fragment>
            <DaySelction user={this.state.userData} day="sunday"/>
            <DaySelction user={this.state.userData} day="monday"/>
            <DaySelction user={this.state.userData} day="tuesday"/>
            <DaySelction user={this.state.userData} day="wednesday"/>
            <DaySelction user={this.state.userData} day="thursday"/>
            <DaySelction user={this.state.userData} day="friday"/>
            <DaySelction user={this.state.userData} day="saturday"/>
        </React.Fragment>


        return (
            <React.Fragment>
                {headline}
                {sideDrawer}
                {backDrop}
                <Container className={classes.container} component="main" maxWidth="xs"
                           style={{fontFamily: "Open Sans Hebrew"}}>
                    <div align="center" style={{fontFamily: "Open Sans Hebrew"}}>
                        <div className={classes.top_text} style={{fontFamily: "Open Sans Hebrew"}}>
                            {this.state.first_signup_headline}
                        </div>
                        <br/>
                        {this.state.activity_status}
                        <ShowGeneralInfo ref={this.showGeneralInfo}
                                         user={this.state.userData}
                                         full_name_label="* שם מלא של ההורה"
                        />
                         <div className={classes.input_text}>
                            * עיר מגורים  
                        </div>
                        <Autocomplete 
                            id="city"
                            name = "city"
                            options={cities}
                            fullWidth
                            value = {this.state.city || ""}
                            onChange={(e,value) => this.handleChangeCombo("city", value)}
                            size="small"
                            renderInput={params => <TextField {...params}        
                                        name = "city" variant="outlined" />}/>
                        <br/>
                        <p>{errors.city.length > 0 && <span className='error' style={errStyle}>{errors.city}</span>}</p> 
                        {child_info}
                        <br/>
                        <br/>
                        <ExtraChild extra_child={this.state.extra_child} extraChildStatus={this.extraChildStatus}/>
                        {this.state.extra_child ? extra_child_info : null}
                        <br/>

                        <ShowDaySelction daysSelections={this.state.show_day_selection}
                                         handleClick={this.handleShowJobDetails}/>
                        {this.state.show_day_selection ? day_selecetions : null}

                        <p className={classes.input_text}>*להמשך בירור פרטים והתקשרות יש ליצור קשר עם נותן השירות </p>
                        {this.setRegisterButtonLable()}
                    </div>
                </Container>
            </React.Fragment>

        );
    }
}

function mapStateToProps(state) {
    return {
        isLoggingOut: state.auth.isLoggingOut,
        logoutError: state.auth.logoutError,
        currUser: state.currentUser,
    };
}




function loadParentData(is_new_account, city, is_show_details_open) {
    const parent_data = parentData;

    if (is_new_account) {
        parent_data.activity_status = true;
        var date = new Date();
        var month = date.getMonth() + 1;
        var full_date = date.getDate() + "." + month + "." + date.getFullYear();
        parent_data.registration_date = full_date;
    } else {
        console.log(document.getElementsByName("activity_status")[0].checked);
        parent_data.activity_status = document.getElementsByName("activity_status")[0].checked;
    }
    parent_data.full_name = document.getElementsByName("full_name")[0].value;
    parent_data.email = (myFirebase.auth().currentUser.email).toLowerCase();
    parent_data.phone_number = document.getElementsByName("phone_number")[0].value;
    parent_data.region = document.getElementsByName("region")[0].value;
    parent_data.city = city;
    parent_data.child_age = document.getElementsByName("child_age")[0].value;
    if (document.getElementsByName("child_gender")[0].checked) {
        parent_data.child_gender = "female"
    } else {
        parent_data.child_gender = "male"
    }
    parent_data.is_autistic_spectrum = document.getElementsByName("is_autistic_spectrum")[0].checked;
    parent_data.is_intellectual_limitation = document.getElementsByName("is_intellectual_limitation")[0].checked;
    parent_data.is_delayed_developed = document.getElementsByName("is_delayed_developed")[0].checked;
    parent_data.is_physical_limitation = document.getElementsByName("is_physical_limitation")[0].checked;
    parent_data.is_behavioral_difficulty = document.getElementsByName("is_behavioral_difficulty")[0].checked;
    parent_data.is_nursing_assistance = document.getElementsByName("is_nursing_assistance")[0].checked;
    parent_data.is_medical_assistance = document.getElementsByName("is_medical_assistance")[0].checked;
    parent_data.is_other = document.getElementsByName("is_other")[0].checked;
    parent_data.child_functional_level = document.getElementsByName("child_functional_level")[0].value;
    if (document.getElementsByName("child_age")[1] != undefined) {
        if (document.getElementsByName("child_gender")[1].checked) {
            parent_data.extra_child.child_gender = "female";
        } else {
            parent_data.extra_child.child_gender = "male";
        }
        parent_data.extra_child.child_age = document.getElementsByName("child_age")[1].value;
        parent_data.extra_child.is_autistic_spectrum = document.getElementsByName("is_autistic_spectrum")[1].checked;
        parent_data.extra_child.is_intellectual_limitation = document.getElementsByName("is_intellectual_limitation")[1].checked;
        parent_data.extra_child.is_delayed_developed = document.getElementsByName("is_delayed_developed")[1].checked;
        parent_data.extra_child.is_physical_limitation = document.getElementsByName("is_physical_limitation")[1].checked;
        parent_data.extra_child.is_behavioral_difficulty = document.getElementsByName("is_behavioral_difficulty")[1].checked;
        parent_data.extra_child.is_nursing_assistance = document.getElementsByName("is_nursing_assistance")[1].checked;
        parent_data.extra_child.is_medical_assistance = document.getElementsByName("is_medical_assistance")[1].checked;
        parent_data.extra_child.is_other = document.getElementsByName("is_other")[1].checked;
        parent_data.extra_child.child_functional_level = document.getElementsByName("child_functional_level")[1].value;
    }
    if(is_show_details_open) {
        parent_data.work_on_sunday.is_needed = document.getElementsByName("sunday")[0].checked;
        if(parent_data.work_on_sunday.is_needed) {
            parent_data.work_on_sunday.start_time = document.getElementsByName("sunday_start")[0].value;
            parent_data.work_on_sunday.end_time = document.getElementsByName("sunday_end")[0].value;
        }
    
        parent_data.work_on_monday.is_needed = document.getElementsByName("monday")[0].checked;
        if(parent_data.work_on_monday.is_needed) {
            parent_data.work_on_monday.start_time = document.getElementsByName("monday_start")[0].value;
            parent_data.work_on_monday.end_time = document.getElementsByName("monday_end")[0].value;
        }
    
        parent_data.work_on_tuesday.is_needed = document.getElementsByName("tuesday")[0].checked;
        if(parent_data.work_on_tuesday.is_needed) {
            parent_data.work_on_tuesday.start_time = document.getElementsByName("tuesday_start")[0].value;
            parent_data.work_on_tuesday.end_time = document.getElementsByName("tuesday_end")[0].value;
        }
    
        parent_data.work_on_wednesday.is_needed = document.getElementsByName("wednesday")[0].checked;
        if(parent_data.work_on_wednesday.is_needed) {
            parent_data.work_on_wednesday.start_time = document.getElementsByName("wednesday_start")[0].value;
            parent_data.work_on_wednesday.end_time = document.getElementsByName("wednesday_end")[0].value;
        }
    
        parent_data.work_on_thursday.is_needed = document.getElementsByName("thursday")[0].checked;
        if(parent_data.work_on_thursday.is_needed) {
            parent_data.work_on_thursday.start_time = document.getElementsByName("thursday_start")[0].value;
            parent_data.work_on_thursday.end_time = document.getElementsByName("thursday_end")[0].value;
        }
    
        parent_data.work_on_friday.is_needed = document.getElementsByName("friday")[0].checked;
        if(parent_data.work_on_friday.is_needed) {
            parent_data.work_on_friday.start_time = document.getElementsByName("friday_start")[0].value;
            parent_data.work_on_friday.end_time = document.getElementsByName("friday_end")[0].value;
        }
    
        parent_data.work_on_saturday.is_needed = document.getElementsByName("saturday")[0].checked;
        if(parent_data.work_on_saturday.is_needed) {
            parent_data.work_on_saturday.start_time = document.getElementsByName("saturday_start")[0].value;
            parent_data.work_on_saturday.end_time = document.getElementsByName("saturday_end")[0].value;
        }
    }

    return parent_data;
}


export default withStyles(useStyles)(connect(mapStateToProps)(ParentSignup));

